import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const LOGO_URL =
  "/assets/adr4solutions-logo.png";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[var(--navy)] text-[var(--ivory)] pt-16 pb-8" data-testid="adr-footer">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <div className="bg-[var(--ivory)] p-1.5">
                <img src={LOGO_URL} alt="ADR 4 Solutions" className="h-8 w-8 object-contain" />
              </div>
              <span className="font-serif text-[20px] tracking-wide">
                ADR <span className="text-[var(--champagne)]">4</span> Solutions
              </span>
            </div>
            <p className="font-serif italic text-[18px] mt-6 text-[var(--ivory)]">
              {t.footer.tagline}
            </p>
            <p className="mt-4 text-[13px] leading-[1.7] text-[#A0B0C4] max-w-md">
              {t.footer.desc}
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="overline mb-5" style={{ color: "var(--champagne)" }}>Navigazione</p>
            <ul className="space-y-3">
              {["services", "experience", "method", "founder", "contact"].map((id) => (
                <li key={id}>
                  <a
                    className="footer-link"
                    href={`#${id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.getElementById(id);
                      if (el) {
                        const y = el.getBoundingClientRect().top + window.scrollY - 80;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    }}
                  >
                    {t.nav[id]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="overline mb-5" style={{ color: "var(--champagne)" }}>Contatti</p>
            <ul className="space-y-3 text-[13px]">
              <li><a className="footer-link" href="mailto:info@adr4solutions.it">info@adr4solutions.it</a></li>
              <li><a className="footer-link" href="mailto:info.adr4solutions@gmail.com">info.adr4solutions@gmail.com</a></li>
              <li><a className="footer-link" href="tel:+393478109745">+39 347 810 9745</a></li>
              <li>
                <a
                  className="footer-link"
                  href="https://www.linkedin.com/company/adr4solutions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                >
                  {t.footer.linkedin}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[var(--border-dark)]">
         <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="text-[12px] text-[#A0B0C4]">
          © {new Date().getFullYear()} ADR 4 Solutions. {t.footer.rights}
          </p>

        <div className="flex items-center gap-6 text-[12px]">
          <a className="footer-link" href="#" data-testid="footer-privacy">{t.footer.privacy}</a>
          <a className="footer-link" href="#" data-testid="footer-cookie">{t.footer.cookie}</a>
        </div>
        </div>

        <div className="mt-10 md:mt-12 text-center text-[10px] md:text-[11px] text-[#A0B0C4]/60 leading-relaxed tracking-[0.02em]">
          <p>Di Rienzo Alessandro – ADR 4 Solutions</p>
          <p>P.IVA 13302640019 • Sede legale: Alpignano (TO), Italia</p>
          <p>PEC: alessandrodirienzo@arubapec.it</p>
        </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
